import { makeVar } from '@apollo/client';
import type { DataGridProps, GridState } from '@cmg/data-grid';
import { getColDefId } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../../graphql';
import { relationshipStatusColDef } from './columns/relationship-status';
import type { SalesCoverageUnderwriterEmployeeInvestorCoverageFragment } from './graphql/__generated__';

export type InvestorCoverageRow = SalesCoverageUnderwriterEmployeeInvestorCoverageFragment;

export type InvestorCoverageGridContext = {
  isEditable: boolean;
};

export const AUTO_SIZE_STRATEGY: DataGridProps<InvestorCoverageRow>['autoSizeStrategy'] = {
  type: 'fitGridWidth',
};

export const INITIAL_INVESTOR_COVERAGE_GRID_STATE: GridState = {
  filter: {
    filterModel: {
      [getColDefId(relationshipStatusColDef)]: {
        values: [RolodexRecordStatus.Effective],
        filterType: 'set',
      },
    },
  },
};

export function canEmployeeEditCoverage(employeeStatus: RolodexRecordStatus): boolean {
  return employeeStatus !== RolodexRecordStatus.Deleted;
}

export type InvestorCoverageSelectOption<TValue> = {
  label: string;
  value: TValue;
};

export const refetchFirmInvestorCoverageGridReactiveVar = makeVar(false);
